import { styled } from "@mui/material";

const StyledPickLocationModal = styled('div')`
  position: relative;
  width: 100%;
  height: 100%;

  .coords-location-marker {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);

    &__svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-100%);
    }
  }

  .coords-location-select {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;

    &__btn {
      width: 100%;
      justify-content: center;
    }
  }
`;

export {
  StyledPickLocationModal
};
